import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { GalleryCarousel } from '../GalleryCarousel';
export function GallerySection() {
  return <section className="bg-cream-deep px-5 py-20 md:py-28" data-id="element-126" data-mp="vomu2p2xjs8o">
      <div className="mx-auto max-w-6xl" data-id="element-127" data-mp="qwd273i98i3r">
        <SectionHeading title="Mirá lo que incluye." data-id="element-128" data-mp="qv1vovxfcw8y" />
        <div className="mt-12" data-id="element-129" data-mp="lyti3myvlb3w">
          <GalleryCarousel data-id="element-130" data-mp="lxrxorvyzc9i" />
        </div>
      </div>
    </section>;
}